import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getMeasureDetails(state) {
    return state.data
  },
}

export const mutations = {
  SET_MEASURE_DETAILS_REQUESTED(state) {
    state.loading = true
  },
  SET_MEASURE_DETAILS_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_MEASURE_DETAILS_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
}

export const actions = {
  async getDetailsById({ commit }, params) {
    commit('SET_MEASURE_DETAILS_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/measure/get/',
        payload: { ...params },
      })
      commit('SET_MEASURE_DETAILS_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_MEASURE_DETAILS_RECEIVED_FAILED', error)
    }
  },
  async deleteMeasureById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/measure/delete/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
